<template>
    <div style="margin-bottom: 15px">
        <h2>
            <span style="color: #4874CB;">{{title}}</span>
        </h2>
        <template v-if="typeof content=== 'string'">
            <template v-for="(t, index) in content.split('\n')" :key="index">
                <p v-if="t.trim()">{{t}}</p>
            </template>
        </template>
        <template v-else>
            <slot name="content"></slot>
        </template>
    </div>
</template>

<script>
    export default {
        name: "LinsCard",
        props: ['title', 'content', 'size'],
        components: {
        }
    }
</script>

<style scoped>

</style>